import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

const drawerWidth = 245;

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    backgroundColor: theme.palette.colors.backgroundColor,
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
    paddingLeft: 34,
  },
  topPadding: {
    height: 55,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
    color: '#ffffff',
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerAnchor: {
    borderRight: 'none',
    paddingRight: 24,
  },
  appBarSpacer: {
    ...theme.mixins.toolbar,
    '@media (min-width: 600px)': {
      minHeight: 55,
    },
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    backgroundColor: theme.palette.colors.backgroundColor,
    paddingTop: theme.spacing(2),
    paddingBottom: 20,
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
}));
